/** Fallback site-wide announcement when no active Convex announcement is configured. */
export type SiteAnnouncement = {
  text: string;
  linkText?: string;
  linkUrl?: string;
  startsAt?: string;
  endsAt?: string;
};

export const DEFAULT_PRIVATE_EVENTS_ANNOUNCEMENT: SiteAnnouncement = {
  text: "Host your private event at Tuscan Cove",
  linkText: "Plan your event",
  linkUrl: "/private-events",
};

export const TUSCAN_JULY_3_PRIVATE_BUYOUT_ANNOUNCEMENT: SiteAnnouncement = {
  text: "Closed for Private Buyout today. Open July 4, 4:00-8:00 PM.",
  startsAt: "2026-07-03T00:00:00-07:00",
  endsAt: "2026-07-04T00:00:00-07:00",
};

export function isSiteAnnouncementActive(
  announcement: SiteAnnouncement | null | undefined,
  now = new Date(),
): announcement is SiteAnnouncement {
  if (!announcement?.text?.trim()) {
    return false;
  }

  const nowTime = now.getTime();
  const startsAt = announcement.startsAt ? Date.parse(announcement.startsAt) : null;
  const endsAt = announcement.endsAt ? Date.parse(announcement.endsAt) : null;

  if (startsAt !== null && nowTime < startsAt) {
    return false;
  }

  if (endsAt !== null && nowTime >= endsAt) {
    return false;
  }

  return true;
}

export function resolveSiteAnnouncement(
  activeAnnouncement: SiteAnnouncement | null | undefined,
): SiteAnnouncement | null {
  if (activeAnnouncement?.text?.trim()) {
    return activeAnnouncement;
  }
  return DEFAULT_PRIVATE_EVENTS_ANNOUNCEMENT;
}
